import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HelpdeskService } from 'src/app/services/delavci/helpdesk.service';
import { MainService } from 'src/app/services/delavci/main.service';
import { HelpersService } from 'src/app/services/shared/helpers.service';
import { WarehouseAppService } from 'src/app/services/warehouse-app.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-aplikacija-home-document',
  templateUrl: './aplikacija-home-document.component.html',
  styleUrls: ['./aplikacija-home-document.component.css'],
})
export class AplikacijaHomeDocumentComponent implements OnInit {

  document: any;  
  documentId: string;
  documentType: string;
  isLoading: boolean = true; 

  constructor(private mainService: MainService, private router: Router, private helpersService: HelpersService,
    private deviceService: DeviceDetectorService, private helpdeskService: HelpdeskService, private warehouseAppService: WarehouseAppService) {
  }

  ngOnInit() {
    const data = history.state;
    if (data && data.documents) {
      this.document = data.documents[0];
      this.fetchDocumentDetails();
    } else {
      console.error("No data received.");
      this.isLoading = false; 
    }
  }

  fetchDocumentDetails() {
    if (this.document.type === "DOCUMENT") {
      this.warehouseAppService.mobileSearchScanDocuments(this.document.id).subscribe(data => {
        this.document = data.documents[0];
        this.isLoading = false; 
      }, error => {
        console.error("Error occurred while fetching data:", error);
        this.isLoading = false;
      });
    } else {
      this.isLoading = false; 
    }
  }

  navigateToAplikacijaHome() {
    this.router.navigateByUrl('/aplikacija-home');
  }


}
